import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { allNews } from "@/lib/media";

export default function NewsPreview() {
  const list = allNews.slice(0, 5);

  return (
    <section className="mx-auto mt-16 max-w-[1280px] px-4 md:mt-20 md:px-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_1fr] lg:gap-10">
        <div>
          <SectionHeading
            eyebrow="影视资讯"
            title="最新动态 · 行业快讯"
            desc="关注影视行业的最新消息、口碑动态与内容趋势。"
          />
          {list[0] && (
            <Link
              to={`/news/${list[0].id}`}
              className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 shadow-sm transition-all duration-300 hover:shadow-md"
            >
              <div className="relative h-52 w-full overflow-hidden md:h-64">
                <img
                  src={list[0].cover}
                  alt={list[0].title}
                  title={`${list[0].title} - 91蜜桃影视资讯`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
                  {list[0].category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {list[0].title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm text-foreground-500">
                  {list[0].summary}
                </p>
                <p className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {list[0].date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line" />
                    {list[0].author}
                  </span>
                </p>
              </div>
            </Link>
          )}
        </div>

        <div>
          <div className="mb-6 flex items-center justify-between md:mb-8">
            <h3 className="font-heading text-lg font-bold text-foreground-950">资讯速览</h3>
            <Link
              to="/news"
              className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600"
            >
              全部资讯
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <ul className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {list.slice(1).map((item) => (
              <li key={item.id}>
                <Link
                  to={`/news/${item.id}`}
                  className="group flex items-start gap-3 p-4 transition-colors hover:bg-background-100"
                >
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-50 text-xs font-bold text-primary-600">
                    {item.category.slice(0, 1)}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </span>
                    <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-calendar-line" />
                      {item.date}
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}